export const SpaceCollaboratorFactory = Symbol.for('SpaceCollaboratorFactory');
